// Demo authentication utility for testing

// Use a hardcoded valid JWT token for demo purposes
// This token is valid for the admin user and expires in 24 hours
const DEMO_JWT_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjkwMmFmNDY5LWUxMjctNDZkMC1iYjM3LTIwMmIwZGMxZmRjYSIsImVtYWlsIjoiYW5kcmV3am9obnZlcmN1ZWlsQGdtYWlsLmNvbSIsInJvbGUiOiJhZG1pbiIsImlhdCI6MTc1MTU4NTE2OSwiZXhwIjoxNzUxNjcxNTY5fQ.OKMXxPuRBCzVNPzw8JCK7uVi79oKTaSAgOMAi0qCK88';

export const setupDemoAuth = () => {
  // Use the admin user for demo purposes since workflows require authentication
  const demoUser = {
    id: '902af469-e127-46d0-bb37-202b0dc1fdca', // Admin user ID from database
    email: 'andrewjohnvercueil@gmail.com',
    role: 'admin',
    iat: Math.floor(Date.now() / 1000),
    exp: Math.floor(Date.now() / 1000) + (24 * 60 * 60) // 24 hours
  };

  // Use the hardcoded valid JWT token
  const demoToken = DEMO_JWT_TOKEN;
  
  // Store in localStorage
  localStorage.setItem('token', demoToken);
  
  // Also store user data for auth context
  const userForContext = {
    id: demoUser.id,
    email: demoUser.email,
    firstName: 'Andrew',
    lastName: 'Vercueil',
    role: demoUser.role,
    isActive: true,
    emailVerified: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  };
  
  console.log('🎬 Demo authentication setup complete!');
  console.log('Demo user token stored in localStorage');
  
  return { token: demoToken, user: userForContext };
};

export const clearDemoAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  console.log('🧹 Demo authentication cleared');
};

export const isDemoMode = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;
  
  try {
    // Parse the JWT payload
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.email === 'andrewjohnvercueil@gmail.com' || payload.email === 'demo@trybombard.com';
  } catch {
    return false;
  }
};

// Auto-setup demo authentication if no token exists
export const autoSetupDemoAuth = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.log('🎭 No authentication token found, setting up demo authentication...');
    return setupDemoAuth();
  }
  return null;
}; 